import { Component } from '@angular/core';
import { BasePage, iConfiguracion } from '../../models/basePage';
import {
  NavController,
  Platform,
  ToastController,
  ViewController,
  ActionSheetController,
  ActionSheet,
  MenuController,
  Nav,
  NavParams,
  LoadingController
} from 'ionic-angular';
import {
  pouchdb
} from '../../services/pouchdb/pouchdb.service';
import { API, APIOnLine } from '../../services/api/api.services';
import { EquipoPage } from '../../pages/equipo/equipo';
import { AlineacionPage } from '../../pages/alineacion/alineacion';
import { App } from 'ionic-angular/components/app/app';
import { FirmasPage } from '../../pages/firmas/firmas';
import { ResultadoPage } from '../../pages/resultado/resultado';
import { GolesPage } from '../../pages/goles/goles';
import { AmonestacionesPage } from '../../pages/amonestaciones/amonestaciones';
import { CambiosPage } from '../../pages/cambios/cambios';
import { DerechosPage } from '../../pages/derechos/derechos';
import { IncidenciasPage } from '../../pages/incidencias/incidencias';
import { ResumenPage } from '../../pages/resumen/resumen';
import { CustodiaPage } from '../../pages/custodia/custodia';
import { ParticipacionPage } from '../../pages/participacion/participacion';
import { QuintetoPage } from '../../pages/quinteto/quinteto';
import { TiempoMuertoPage } from '../../pages/tiempo-muerto/tiempo-muerto';
import { FinalizarPage } from '../../pages/finalizar/finalizar';
import { Http } from "@angular/http";
import { Proxy } from '../../services/proxy/proxy.service';

export interface iMenuDerecho {
  titulo: string;
  componente: any;
  idDesignacion: number;
  esLocal?: boolean;
  tipo?: string;
  esIncidencia?: boolean;
  final?: boolean;
}

@Component({
  selector: 'menu-derecho',
  templateUrl: 'menu-derecho.html'
})
export class MenuDerechoComponent extends BasePage {
  // #region Propiedades del componente
  public paginas: Array<iMenuDerecho> = [];
  public confirmadas: boolean = false;
  public cargando: boolean = true;

  public desig: Proxy.PrDesignaciones;
  // #endregion

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public navCtrl: NavController,
    public platform: Platform,
    public Params: API.ParametrosAlineacion,
    public toastCtrl: ToastController,
    public DBService: pouchdb.DBService,
    public SessionService: API.SessionService,
    public actionSheetCtrl: ActionSheetController,
    public menuCtrl: MenuController,
    private app: App,
    public loadingCtrl: LoadingController,
    public http: Http,
    public Persistentes: APIOnLine.Persistentes
  ) {
    super(navCtrl, platform, http, toastCtrl, DBService, loadingCtrl);
    console.log('--- accediendo al menú derecho ...');

    this.desig = this.Persistentes.GetDesignacion();
    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        // Inicialización de las páginas que debe tener el menú
        if (!this.desig.OtrosDatos.alineacionesTerminadas) {
          this.paginas = [
            {
              titulo: 'Equipo local',
              componente: EquipoPage,
              esLocal: true,
              idDesignacion: this.desig.idDesignacion
            },
            {
              titulo: 'Equipo visitante',
              componente: EquipoPage,
              esLocal: false,
              idDesignacion: this.desig.idDesignacion
            },
            {
              titulo: 'Alineación local',
              componente: AlineacionPage,
              esLocal: true,
              idDesignacion: this.desig.idDesignacion
            },
            {
              titulo: 'Alineación visitante',
              componente: AlineacionPage,
              esLocal: false,
              idDesignacion: this.desig.idDesignacion
            },
            {
              titulo: 'Firma capitán local',
              componente: FirmasPage,
              esLocal: true,
              idDesignacion: this.desig.idDesignacion,
              tipo: 'C'
            },
            {
              titulo: 'Firma entrenador local',
              componente: FirmasPage,
              esLocal: true,
              idDesignacion: this.desig.idDesignacion,
              tipo: 'E'
            },
            {
              titulo: 'Firma capitán visitante',
              componente: FirmasPage,
              esLocal: false,
              idDesignacion: this.desig.idDesignacion,
              tipo: 'C'
            },
            {
              titulo: 'Firma entrenador visitante',
              componente: FirmasPage,
              esLocal: false,
              idDesignacion: this.desig.idDesignacion,
              tipo: 'E'
            },
            {
              titulo: 'Firma delegado campo',
              componente: FirmasPage,
              esLocal: true,
              idDesignacion: this.desig.idDesignacion,
              tipo: 'A'
            }
          ];

          // TODO: Añadir a la designación, la información de confirmación de las alineaciones
          if (this.confirmadas) {
            this.paginas.push({
              titulo: 'Custodia',
              componente: CustodiaPage,
              esLocal: false,
              idDesignacion: this.desig.idDesignacion,
              final: true
            });
          }
        }
        else {
          if (this.desig.OtrosDatos.actaCerrada) {
            // Al estar cerrada la designación, solamente se mostrará el estado de FINALIZAR
            this.paginas.push({
              titulo: 'Finalizar',
              componente: FinalizarPage,
              idDesignacion: this.desig.idDesignacion,
              final: true
            });
          }
          else {
            // Todos los estados posibles
            this.paginas.push({
              titulo: 'Resultado',
              componente: ResultadoPage,
              idDesignacion: this.desig.idDesignacion,
              esLocal: false
            });
            // Se comprueba si se ha marcado el partido como 'disputado' o 'suspendido iniciado', para activar los estados correspondientes
            if (this.desig.estado == 'disputado' || this.desig.estado == 'suspendido iniciado') {
              // Se comprueba si es fútbol sala
              if (this.desig.Configuracion.esFutbolSala || this.desig.Configuracion.esFutbolPlaya) {
                this.paginas.push({
                  titulo: 'Participación local',
                  componente: ParticipacionPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Goles local',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Amonestaciones local',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true,
                  esIncidencia: false
                });
                this.paginas.push({
                  titulo: 'Participación visitante',
                  componente: ParticipacionPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Goles visitante',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Amonestaciones visitante',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false,
                  esIncidencia: false
                });

                if (this.desig.Configuracion.esFutbolSala) {

                  this.paginas.push({
                    titulo: 'Quintetos finales',
                    componente: QuintetoPage,
                    idDesignacion: this.desig.idDesignacion,
                    esLocal: false
                  });
                  this.paginas.push({
                    titulo: 'Tiempos muertos',
                    componente: TiempoMuertoPage,
                    idDesignacion: this.desig.idDesignacion
                  });

                }

              } else if (this.desig.Configuracion.obligadaParticipacion) {
                this.paginas.push({
                  titulo: 'Participación local',
                  componente: ParticipacionPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Goles local',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Amonestaciones local',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true,
                  esIncidencia: false
                });
                this.paginas.push({
                  titulo: 'Participación visitante',
                  componente: ParticipacionPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Goles visitante',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Amonestaciones visitante',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false,
                  esIncidencia: false
                });
              } else {
                this.paginas.push({
                  titulo: 'Cambios local',
                  componente: CambiosPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Goles local',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                this.paginas.push({
                  titulo: 'Amonestaciones local',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true,
                  esIncidencia: false
                });
                this.paginas.push({
                  titulo: 'Cambios visitante',
                  componente: CambiosPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Goles visitante',
                  componente: GolesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false
                });
                this.paginas.push({
                  titulo: 'Amonestaciones visitante',
                  componente: AmonestacionesPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: false,
                  esIncidencia: false
                });
              }

              // Incorporación de las últimas opciones de la segunda parte, común para todas las modalidades
              if (resultado.derechosArbitrales.activar) {
                this.paginas.push({
                  titulo: 'Derechos local',
                  componente: DerechosPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                if (this.desig && this.desig.Derechos && this.desig.Derechos.compartido) {
                  this.paginas.push({
                    titulo: 'Derechos visitante',
                    componente: DerechosPage,
                    idDesignacion: this.desig.idDesignacion,
                    esLocal: false
                  });
                }
              }

              this.paginas.push({
                titulo: 'Incidencias',
                componente: IncidenciasPage,
                idDesignacion: this.desig.idDesignacion,
                esLocal: false
              });
              this.paginas.push({
                titulo: 'Otras incidencias local',
                componente: AmonestacionesPage,
                idDesignacion: this.desig.idDesignacion,
                esLocal: true,
                esIncidencia: true
              });
              this.paginas.push({
                titulo: 'Otras incidencias visitante',
                componente: AmonestacionesPage,
                idDesignacion: this.desig.idDesignacion,
                esLocal: false,
                esIncidencia: true
              });
              this.paginas.push({
                titulo: 'Firma delegado local',
                componente: ResumenPage,
                idDesignacion: this.desig.idDesignacion,
                esLocal: true
              });
              this.paginas.push({
                titulo: 'Firma delegado visitante',
                componente: ResumenPage,
                idDesignacion: this.desig.idDesignacion,
                esLocal: false
              });
              this.paginas.push({
                titulo: 'Finalizar',
                componente: FinalizarPage,
                idDesignacion: this.desig.idDesignacion,
                final: true
              });
            } else if (this.desig.estado == 'suspendido no iniciado') {
              if (resultado.derechosArbitrales.activar) {
                // Estado de suspendido. Solamente se activan las páginas de 'Resultado', 'Derechos' y 'Finalizar'
                this.paginas.push({
                  titulo: 'Derechos local',
                  componente: DerechosPage,
                  idDesignacion: this.desig.idDesignacion,
                  esLocal: true
                });
                if (this.desig && this.desig.Derechos && this.desig.Derechos.compartido) {
                  this.paginas.push({
                    titulo: 'Derechos visitante',
                    componente: DerechosPage,
                    idDesignacion: this.desig.idDesignacion,
                    esLocal: false
                  });
                }
              }
              this.paginas.push({
                titulo: 'Finalizar',
                componente: FinalizarPage,
                idDesignacion: this.desig.idDesignacion,
                final: true
              });
            }
          }
        }
      });
  }

  // #region Métodos del controlador

  public IrA(pagina: iMenuDerecho): void {
    // Se comprueba si se está en la misma página a la que se intenta ir
    let nav: Nav = this.app.getRootNav();
    let actual: ViewController = nav.getActive();
    let idEquipoActual: number =
      actual != null && actual.data != null && actual.data.idEquipo != null
        ? parseInt(actual.data.idEquipo)
        : 0;

    switch (actual.name) {
      case 'EquipoPage':
        let esLocal: boolean =
          idEquipoActual == this.designacion.idEquipoLocal ? true : false;

        if (
          (pagina.componente == EquipoPage &&
            (pagina.esLocal &&
              this.designacion.idEquipoLocal == idEquipoActual)) ||
          (!pagina.esLocal &&
            this.designacion.idEquipoVisitante == idEquipoActual)
        ) {
          // No se realiza nada porque se está en la misma página
          console.log('Se intenta cambiar a la misma página');
        } else {
          // Se debe comprobar si se cumplen las condiciones para avanzar o retroceder a la página correspondiente
          if (this.CumpleCondicionesAlineacion(esLocal).trim().length > 0) {
            // Mostrar aviso de que no se cumplen las condiciones para cambiar de vista
            let action: ActionSheet = this.actionSheetCtrl.create({
              buttons: [
                {
                  text: 'Seguir',
                  handler: () => {
                    nav.push(pagina.componente, {
                      idDesignacion: pagina.idDesignacion,
                      idEquipo: pagina.esLocal
                        ? this.designacion.idEquipoLocal
                        : this.designacion.idEquipoVisitante,
                      tipo: pagina.tipo
                    });
                  }
                },
                {
                  text: 'Cancelar',
                  role: 'cancel'
                }
              ],
              title: 'No se cumplen las condiciones',
              subTitle: this.CumpleCondicionesAlineacion(esLocal)
            });
            action.present();
          } else {
            this.menuCtrl
              .close()
              .then(resultado => {
                return nav.push(pagina.componente, {
                  idDesignacion: pagina.idDesignacion,
                  idEquipo: pagina.esLocal
                    ? this.designacion.idEquipoLocal
                    : this.designacion.idEquipoVisitante,
                  tipo: pagina.tipo
                });
              })
              .catch(error => this.Error(JSON.stringify(error), "menu-derecho", "IrA", "ERROR: Se ha producido un error intentando cerrar el menú derecho de la aplicación, desde la página de Equipo."));
          }
        }
        break;

      case 'ResultadoPage':
        console.log("Accedo al menú derecho desde ResultadoPage");
        if (this.designacion != null && (this.designacion.jugado == 3 || this.designacion.jugado == 4) && this.designacion.motivoSuspension.length == 0) {
          this.Mensaje("Es necesario que indique el motivo de la suspensión del partido", "", 6000);
        }
        else {
          this.menuCtrl
            .close()
            .then(() => {
              return nav.push(pagina.componente, {
                idDesignacion: pagina.idDesignacion,
                idEquipo: pagina.esLocal
                  ? this.designacion.idEquipoLocal
                  : this.designacion.idEquipoVisitante,
                tipo: pagina.tipo,
                esIncidencia:
                  pagina.esIncidencia != undefined ? pagina.esIncidencia : false
              });
            })
            .catch(error => this.Error(JSON.stringify(error), "menu-derecho", "IrA", "ERROR: Se ha producido un error intentando cerrar el menú derecho de la aplicación, desde la opción " + actual.name.replace("Page", "") + "."));
        }
        break;

      case 'AlineacionPage':
      case 'FirmasPage':
      case 'GolesPage':
      case 'CambiosPage':
      case 'AmonestacionesPage':
      case 'IncidenciasPage':
      case 'OtrasincidenciasPage':
      case 'ResumenPage':
      case 'CustodiaPage':
      case 'TiempoMuertoPage':
      case 'FinalizarPage':
        this.menuCtrl
          .close()
          .then(() => {
            return nav.push(pagina.componente, {
              idDesignacion: pagina.idDesignacion,
              idEquipo: pagina.esLocal
                ? this.designacion.idEquipoLocal
                : this.designacion.idEquipoVisitante,
              tipo: pagina.tipo,
              esIncidencia:
                pagina.esIncidencia != undefined ? pagina.esIncidencia : false
            });
          })
          .catch(error => this.Error(JSON.stringify(error), "menu-derecho", "IrA", "ERROR: Se ha producido un error intentando cerrar el menú derecho de la aplicación, desde la opción " + actual.name.replace("Page", "") + "."));
        break;

      case 'DerechosPage':
        if (!this.PagoRealizado(idEquipoActual == this.designacion.idEquipoLocal ? true : false)) {
          // Mostrar aviso de que no se cumplen las condiciones para cambiar de vista
          let action: ActionSheet = this.actionSheetCtrl.create({
            title: 'Derechos no establecidos',
            subTitle:
              'Los derechos arbitrales no están establecidos. ¿Quiere cambiar de pantalla?',
            buttons: [
              {
                text: 'Sí',
                handler: () => {
                  nav.push(pagina.componente, {
                    idDesignacion: pagina.idDesignacion,
                    idEquipo: pagina.esLocal
                      ? this.designacion.idEquipoLocal
                      : this.designacion.idEquipoVisitante,
                    tipo: pagina.tipo
                  });
                }
              },
              {
                text: 'Cancelar',
                role: 'cancel'
              }
            ]
          });
          action.present();
        } else {
          this.menuCtrl
            .close()
            .then(() => {
              return nav.push(pagina.componente, {
                idDesignacion: pagina.idDesignacion,
                idEquipo: pagina.esLocal
                  ? this.designacion.idEquipoLocal
                  : this.designacion.idEquipoVisitante,
                tipo: pagina.tipo,
                esIncidencia:
                  pagina.esIncidencia != undefined ? pagina.esIncidencia : false
              });
            })
            .catch(error => this.Error(JSON.stringify(error), "menu-derecho", "IrA", "ERROR: Se ha producido un error intentando cerrar el menú derecho de la aplicación, desde la opción Derechos arbitrales."));
        }
        break;

      case 'ParticipacionPage':
        if (
          this.designacion.competicion.obligatoriaParticipacion ||
          this.designacion.competicion.obligatoriaParticipacion
        ) {
          if (
            (pagina.esLocal &&
              this.designacion.partido.listaParticipantesLocal.length ==
              this.designacion.partido.listaSuplentesLocal.length) ||
            (!pagina.esLocal &&
              this.designacion.partido.listaParticipantesVisitante.length ==
              this.designacion.partido.listaSuplentesVisitante.length)
          ) {
            this.navCtrl.push(pagina.componente, {
              idDesignacion: this.desig.idDesignacion,
              idEquipo: pagina.esLocal
                ? this.designacion.idEquipoLocal
                : this.designacion.idEquipoVisitante
            });
          } else {
            // Todos los suplentes no han participado
            let action: ActionSheet = this.actionSheetCtrl.create({
              title: 'Suplentes no han participado',
              subTitle:
                'Hay jugadores suplentes que no han participado. ¿Confirma que hay jugadores que no han participado?',
              buttons: [
                {
                  text: 'Confirmar',
                  handler: () => {
                    this.navCtrl.push(pagina.componente, {
                      idDesignacion: this.desig.idDesignacion,
                      idEquipo: pagina.esLocal
                        ? this.designacion.idEquipoLocal
                        : this.designacion.idEquipoVisitante
                    });
                  }
                },
                {
                  text: 'Cancelar',
                  role: 'cancel'
                }
              ]
            });
            action.present();
          }
        } else {
          this.menuCtrl.close().then(() => {
            return nav.push(pagina.componente, {
              idDesignacion: pagina.idDesignacion,
              idEquipo: pagina.esLocal
                ? this.designacion.idEquipoLocal
                : this.designacion.idEquipoVisitante,
              tipo: pagina.tipo,
              esIncidencia:
                pagina.esIncidencia != undefined ? pagina.esIncidencia : false
            });
          });
        }
        break;

      case 'QuintetoPage':
        if (
          this.designacion.partido.quintetoFinalLocal.length != 5 ||
          this.designacion.partido.quintetoFinalVisitante.length != 5
        ) {
          let action: ActionSheet = this.actionSheetCtrl.create({
            title: 'Quintetos no completados',
            subTitle:
              'Uno o los dos quintetos finales no tienen los 5 jugadores establecidos. ¿Confirma que desea cambiar de pantalla?',
            buttons: [
              {
                text: 'Confirmar',
                handler: () => {
                  this.navCtrl.push(TiempoMuertoPage, {
                    idDesignacion: this.desig.idDesignacion,
                    idEquipo: this.designacion.idEquipoLocal
                  });
                }
              },
              {
                text: 'Cancelar',
                role: 'cancel'
              }
            ]
          });
          action.present();
        } else {
          this.navCtrl.push(TiempoMuertoPage, {
            idDesignacion: this.desig.idDesignacion,
            idEquipo: this.designacion.idEquipoLocal
          });
        }
        break;
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/menu-derecho/menu-derecho.ts